import sunglassesThumb1 from '../assets/1b3d2318161de3fe3f16dd3d2e5b673e.jpeg'
import sunglassesThumb2 from '../assets/212468a784a0228b8ff6fb3288f0006e.jpeg'
import sunglassesThumb3 from '../assets/0ed71e4126d827df096727f06b4610af.jpeg'
import sunglassesThumb4 from '../assets/b0c09ed1717bc8827c796eb042e5e665.jpeg'
import sunglassesThumb5 from '../assets/5c9ee76e83e5395093798550bba3d20f.jpeg'
import chainThumb1 from '../assets/c5996d2e9a4c5684b1397d920b0f4715.jpeg'
import chainThumb2 from '../assets/fcadf2ed77d2a690b622f54d41fcf5f8.jpeg'
import chainThumb3 from '../assets/9ba44c3b823e914fe30ba82121e9ad31.jpeg'
import chainThumb4 from '../assets/17c9e25e4ce7b7cd6542dc4096ebd13a.jpeg'
import ringThumb1 from '../assets/2ba1069cd2060fb7203152fb736d3ba8.jpeg'
import ringThumb2 from '../assets/2c19389d74fe30cf8ca82771a68b043a.jpeg'
import ringThumb3 from '../assets/456c988bc9e6d32fe9ea97e983696fdd.jpeg'
import beltThumb1 from '../assets/c8f110cae3311d20a41384c1f6e4834c.jpeg'
import beltThumb2 from '../assets/69f3e8312f1c3e7f1d35243abe229194.jpeg'
import beltThumb3 from '../assets/8df8a7721c89d0eb97f3e0106b762210.jpeg'
import ankleThumb1 from '../assets/ecf2dea83f8c1ff077ae29df12b1d6fe.jpeg'
import ankleThumb2 from '../assets/82c7cb5bef2f1a4b85b08a4295c9bc5e.jpeg'
import ankleThumb3 from '../assets/14c04e6d511712f46497f84182246664.jpeg'
import ankleThumb4 from '../assets/5038156aae3debf6613a0635863371ba.jpeg'
import ankleThumb5 from '../assets/eb90e6c88dfd3fd0a94d5a02a3f6fc47.jpeg'
import ankleThumb6 from '../assets/22d132f15aa286a4d3b30b8e6db87cf7.jpeg'
import shortChinoThumb4 from '../assets/51333262fabe6f312635704a9d9c072f.jpeg'
import shortChinoThumb5 from '../assets/b1df750ebba2460eda678834381815c0.jpeg'
import shortChinoThumb6 from '../assets/dd092ef99b7516059d5ff8186a5db11a.jpeg'
import longDenimThumb1 from '../assets/sg-11134201-22110-ngsyqze8ufjva6.jpeg'
import longDenimThumb2 from '../assets/sg-11134201-22110-azuzzw38ufjv84.jpeg'
import longDenimThumb3 from '../assets/sg-11134201-22110-9y7whuu8ufjv0f.jpeg'
import longDenimThumb4 from '../assets/sg-11134201-22110-5vpql1y8ufjv0c.jpeg'
import longDenimThumb5 from '../assets/a856240821f74b485ee893db2852cb9c.jpeg'
import longDenimThumb6 from '../assets/2aba556ac012623f139c4c5e5b131e2d.jpeg'
import longDenimThumb7 from '../assets/eaf69cab6106847cc06f35f1908edcb8.jpeg'
import shortDenimThumb1 from '../assets/sg-11134201-22100-xtuqotyde2ivb7.jpeg'
import shortDenimThumb2 from '../assets/sg-11134201-22100-y0m8k6koe2iv62.jpeg'
import shortDenimThumb3 from '../assets/sg-11134201-22100-s3mvcipoe2iv3a.jpeg'
import shortDenimThumb4 from '../assets/43a7aaedc54a2227212ac8da0bd81ab8.jpeg'
import shortDenimThumb5 from '../assets/d4c989bb5fc421ae27b72ae7aaecb13c.jpeg'
import osakaShortThumb1 from '../assets/sg-11134201-22100-caut5tf2d2iv2e.jpeg'
import osakaShortThumb2 from '../assets/sg-11134201-22100-q8z2wrn2d2ivd9.jpeg'
import osakaShortThumb3 from '../assets/sg-11134201-22100-2sogxu64d2ived.jpeg'
import osakaShortThumb4 from '../assets/sg-11134201-22100-t3epetb5d2ivce.jpeg'
import osakaShortThumb5 from '../assets/sg-11134201-22100-d7evgfi5d2iv8c.jpeg'
import osakaShortThumb6 from '../assets/55dbe3eae2ae45fb91f1db59ebc784b3.jpeg'
import osakaShortThumb7 from '../assets/01892b6a244755e2c40ee7ba94571770.jpeg'
import osakaShortThumb8 from '../assets/bb0fceeba1c8cca9496561e4cf4d4653.jpeg'
import bomberThumb1 from '../assets/sg-11134201-22100-cqadvlgjuiive3.jpeg'
import bomberThumb2 from '../assets/sg-11134201-22100-ixm75efjuiiv57.jpeg'
import bomberThumb3 from '../assets/sg-11134201-22100-q8bnhrdjuiiv67.jpeg'
import canvasThumb1 from '../assets/sg-11134201-22110-a7e8p3jkwfjvba.jpeg'
import canvasThumb2 from '../assets/sg-11134201-22110-o41ri6ymwfjv11.jpeg'
import canvasThumb3 from '../assets/0f00ac2d15da49a1e430f687b37bf941.jpeg'
import canvasThumb4 from '../assets/sg-11134201-22110-gquotztkwfjvca.jpeg'
import canvasThumb5 from '../assets/146353b8c9954b0f96daf01d85f55890.jpeg'
import canvasThumb6 from '../assets/d6a212f02420efd12ca6588a1a8fe655.jpeg'
import sukajanThumb1 from '../assets/5aaa2f18350dfd05cab2078d7ee469cc.jpeg'
import sukajanThumb2 from '../assets/9ffa127090075e5eaba955283260d11f.jpeg'
import sukajanThumb3 from '../assets/a72159627f26fd9cd5c4bf9abe74651a.jpeg'
import sephaThumb1 from '../assets/id-11134201-23030-3lfpjidjyvove5.jpeg'
import sephaThumb2 from '../assets/id-11134201-23030-524ckfejyvova4.jpeg'
import sephaThumb3 from '../assets/id-11134201-23030-dgnqphdjyvov87.jpeg'
import nanoThumb1 from '../assets/sg-11134201-22110-5501kjadozjv54.jpeg'
import nanoThumb2 from '../assets/sg-11134201-22110-pomjln1cozjv58.jpeg'
import nanoThumb3 from '../assets/sg-11134201-22110-jtnsnnpcozjv3c.jpeg'
import nanoThumb4 from '../assets/sg-11134201-22110-jhqupglcozjv67.jpeg'
import nanoThumb5 from '../assets/678d6cb8d3d0bbf9242e9aa2ac6ed3aa.jpeg'
import nanoThumb6 from '../assets/41e64b750c2ca1eae156116f60f7918e.jpeg'
import nanoThumb7 from '../assets/a7d6254647e6db3b6d60e13a7b6663fe.jpeg'
import japanThumb1 from '../assets/sg-11134201-22110-9uvt5j0nwfjvef.jpeg'
import japanThumb2 from '../assets/sg-11134201-22110-z2cy5r1owfjv33.jpeg'
import japanThumb3 from '../assets/sg-11134201-22110-sr8w0atowfjv6f.jpeg'
import japanThumb4 from '../assets/sg-11134201-22110-3w8dvfbpwfjv2f.jpeg'
import japanThumb5 from '../assets/3c4fe7788a6518493f8628a69b65905c.jpeg'
import japanThumb6 from '../assets/5a05b987819a5a2e21e99eccc1a55c13.jpeg'
import carbonThumb1 from '../assets/7336ae7442956a53e97b364cb37d7b64.jpeg'
import carbonThumb2 from '../assets/sg-11134201-22100-yhd2jf92nbiv9c.jpeg'
import carbonThumb3 from '../assets/sg-11134201-22100-q8zhl0d3nbiv0e.jpeg'
import carbonThumb4 from '../assets/sg-11134201-22100-hdnlpai3nbiv63.jpeg'
import carbonThumb5 from '../assets/4e900f17cf9732ef1693c4cb483d6ca9.jpeg'
import tribowThumb1 from '../assets/sg-11134201-22110-dmzt2rg01fjv7e.jpeg'
import tribowThumb2 from '../assets/sg-11134201-22110-3gjc09o01fjv35.jpeg'
import tribowThumb3 from '../assets/sg-11134201-22110-budu04w01fjv49.jpeg'
import tribowThumb4 from '../assets/sg-11134201-22110-buhp1c401fjva1.jpeg'
import tribowThumb5 from '../assets/sg-11134201-22110-4vp7l8901fjv07.jpeg'
import tribowThumb6 from '../assets/04f7218de9161f73f2b9badb4c3ee221.jpeg'
import tribowThumb7 from '../assets/d3ef1d3c766c718e9f17475971b6f330.jpeg'
import tribowThumb8 from '../assets/e70dc6a8defcd44bf9e516d3f237e3b7.jpeg'
import amariloThumb1 from '../assets/5688ab4e5cf5fdf8735562ecc37442ba.jpeg'
import amariloThumb2 from '../assets/5189039c91441b0aa4b2e06ea370a1bf.jpeg'
import amariloThumb3 from '../assets/1295efd9b74621c89d3d69365b165514.jpeg'
import amariloThumb4 from '../assets/d202fd6f87cd34e431692193d1b3596c.jpeg'
import amariloThumb5 from '../assets/65307c93e5091d855f2acf5b7c687bf1.jpeg'
import amariloThumb6 from '../assets/a3db1f3023198f90d27e1b2310bea849.jpeg'
import amariloThumb7 from '../assets/bf251e577449a1f464e2f01185035685.jpeg'
import amariloThumb8 from '../assets/30f02bcf90427c7cb265729f73487b07.jpeg'
import amariloThumb9 from '../assets/55d32f8c28c584ba538b1a6da2253a5b.jpeg'
import astonThumb1 from '../assets/sg-11134201-22110-svqufyhoqfjv0f.jpeg'
import astonThumb2 from '../assets/sg-11134201-22110-hhm4hdvoqfjv89.jpeg'
import astonThumb3 from '../assets/sg-11134201-22110-5r716evoqfjv12.jpeg'
import astonThumb4 from '../assets/sg-11134201-22110-g7ezr7xoqfjv23.jpeg'
import astonThumb5 from '../assets/505d46ad283ae1a1722e81782ddeb6ce.jpeg'
import astonThumb6 from '../assets/8d2da96abc6ffbf9546e7398b39d53d8.jpeg'
import astonThumb7 from '../assets/c0ca33eb83f0ec1c946074c2fd738ebf.jpeg'
import dallasThumb1 from '../assets/sg-11134201-22100-aboqt1mye2ive6.jpeg'
import dallasThumb2 from '../assets/sg-11134201-22100-cqqpjttye2iv80.jpeg'
import dallasThumb3 from '../assets/sg-11134201-22100-5jc994jze2iv7a.jpeg'
import dallasThumb4 from '../assets/sg-11134201-22100-68uedmpze2iv37.jpeg'
import dallasThumb5 from '../assets/sg-11134201-22100-k1r892uze2iv21.jpeg'
import dallasThumb6 from '../assets/sg-11134201-22100-pnsue5xze2ivb8.jpeg'
import dallasThumb7 from '../assets/sg-11134201-22100-mknlo36zf2iva6.jpeg'
import dallasThumb8 from '../assets/7985d40bccce0ef5b99da5e36bc63ca0.jpeg'
import dallasThumb9 from '../assets/0bc87865b4ff124e29e07f47ad2ac1db.jpeg'
import dallasThumb10 from '../assets/dc467fa9c62ab3fb595f1d4a8dd56460.jpeg'
import flanelThumb1 from '../assets/sg-11134201-23020-192g6f7snhnv18.jpeg'
import flanelThumb2 from '../assets/sg-11134201-23020-4t9gsi9snhnv22.jpeg'
import flanelThumb3 from '../assets/sg-11134201-23020-xg3ehcdtnhnv23.jpeg'
import flanelThumb4 from '../assets/sg-11134201-23020-md5cg2dtnhnvc9.jpeg'
import flanelThumb5 from '../assets/sg-11134201-23020-t4w9wsetnhnv46.jpeg'
import flanelThumb6 from '../assets/sg-11134201-23020-o1mnzxftnhnv9b.jpeg'
import flanelThumb7 from '../assets/sg-11134201-23020-6wntx42snhnv49.jpeg'
import flanelThumb8 from '../assets/sg-11134201-23020-lz77v83snhnva8.jpeg'
import flanelThumb9 from '../assets/sg-11134201-23020-o1yow04snhnvc4.jpeg'
import daviribsThumb1 from '../assets/id-11134201-23030-rtgv8xxmr9nv9d.jpeg'
import daviribsThumb2 from '../assets/id-11134207-23030-x2xuuo72r9nvba.jpeg'
import musiclightThumb1 from '../assets/id-11134201-23030-26t58mvk5jova3.jpeg'
import musiclightThumb2 from '../assets/id-11134207-23030-drekm77l5jov6f.jpeg'
import orangebearThumb1 from '../assets/sg-11134201-23010-006k9v6gjqmvaa.jpeg'
import orangebearThumb2 from '../assets/sg-11134201-23020-p7yc37e2penv80.jpeg'
import orangebearThumb3 from '../assets/id-11134207-23020-9iyjomo2penvec.jpeg'

const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
    ;[array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ]
  }
  return array
}

export const products = [
  // accesssories product
  {
    name: 'basic sunglasses',
    category: 'accessories',
    price: 49000,
    variant: [
      { color: 'vintage transparent', image_path: sunglassesThumb4 },
      { color: 'retro black', image_path: sunglassesThumb5 },
    ],
    size: [],
    image: [sunglassesThumb1, sunglassesThumb2, sunglassesThumb3],
  },
  {
    name: 'stainless premium chain',
    category: 'accessories',
    price: 49000,
    variant: [
      { color: 'silver', image_path: chainThumb3 },
      { color: 'gold', image_path: chainThumb4 },
    ],
    size: [],
    image: [chainThumb1, chainThumb2],
  },
  {
    name: 'rings',
    category: 'accessories',
    price: 29000,
    variant: [{ color: 'silver' }, { color: 'gold' }, { color: 'black' }],
    size: [],
    image: [ringThumb1, ringThumb2, ringThumb3],
  },

  {
    name: 'belt leather',
    category: 'accessories',
    price: 55000,
    variant: [],
    size: [],
    image: [beltThumb1, beltThumb2, beltThumb3],
  },

  //   pants products
  {
    name: 'long ankle pants',
    category: 'pants',
    price: 99000,
    variant: [
      { color: 'grey', image_path: ankleThumb1 },
      { color: 'navy', image_path: ankleThumb2 },
      { color: 'cream', image_path: ankleThumb3 },
      { color: 'black', image_path: ankleThumb4 },
    ],
    size: [28, 30, 32, 34, 36, 38],
    image: [ankleThumb5, ankleThumb6],
  },
  {
    name: 'short chino pants',
    category: 'pants',
    price: 94500,
    variant: [
      { color: 'cream', image_path: shortChinoThumb4 },
      { color: 'grey', image_path: shortChinoThumb5 },
      { color: 'brown', image_path: shortChinoThumb6 },
    ],
    size: [28, 30, 32, 34, 36, 38],
    image: [shortChinoThumb4, shortChinoThumb5, shortChinoThumb6],
  },
  {
    name: 'long denim pants',
    category: 'pants',
    price: 149000,
    variant: [
      { color: 'bleach', image_path: longDenimThumb1 },
      { color: 'old bio', image_path: longDenimThumb2 },
      {
        color: 'old bio bleach',
        image_path: longDenimThumb3,
      },
      {
        color: 'old bio wash',
        image_path: longDenimThumb4,
      },
    ],
    size: [28, 30, 32, 34, 36, 38],
    image: [longDenimThumb5, longDenimThumb6, longDenimThumb7],
  },
  {
    name: 'short denim pants',
    category: 'pants',
    price: 89000,
    variant: [
      { color: 'jet black', image_path: shortDenimThumb1 },
      { color: 'short bleach', image_path: shortDenimThumb2 },
      {
        color: 'short old bio',
        image_path: shortDenimThumb3,
      },
    ],
    size: [28, 30, 32, 34, 36, 38],
    image: [shortDenimThumb4, shortDenimThumb5],
  },
  {
    name: 'osaka short pants',
    category: 'pants',
    price: 69000,
    variant: [
      { color: 'osaka black', image_path: osakaShortThumb1 },
      { color: 'osaka navy', image_path: osakaShortThumb2 },
      { color: 'osaka cream', image_path: osakaShortThumb3 },
      { color: 'osaka khaki', image_path: osakaShortThumb4 },
      { color: 'osaka army', image_path: osakaShortThumb5 },
    ],
    size: ['m', 'l', 'xl'],
    image: [osakaShortThumb6, osakaShortThumb7, osakaShortThumb8],
  },
  //   jacket products
  {
    name: 'bomber jacket',
    category: 'jacket-sweater',
    price: 169000,
    variant: [],
    size: ['m', 'l', 'xl'],
    image: [bomberThumb3, bomberThumb1, bomberThumb2],
  },
  {
    name: 'canvas jacket',
    category: 'jacket-sweater',
    price: 119000,
    variant: [
      { color: 'black', image_path: canvasThumb1 },
      { color: 'navy', image_path: canvasThumb2 },
      { color: 'khaki', image_path: canvasThumb3 },
      { color: 'army', image_path: canvasThumb4 },
    ],
    size: ['m', 'l', 'xl'],
    image: [canvasThumb5, canvasThumb6],
  },
  {
    name: 'sukajan hoodie',
    category: 'jacket-sweater',
    price: 199000,
    variant: [],
    size: ['m', 'l', 'xl'],
    image: [sukajanThumb1, sukajanThumb2, sukajanThumb3],
  },
  {
    name: 'serpha jacket',
    category: 'jacket-sweater',
    price: 189000,
    variant: [],
    size: ['m', 'l', 'xl'],
    image: [sephaThumb1, sephaThumb2, sephaThumb3],
  },
  {
    name: 'nano premium sweater',
    category: 'jacket-sweater',
    price: 129000,
    variant: [
      { color: 'nano black', image_path: nanoThumb1 },
      { color: 'nano navy', image_path: nanoThumb2 },
      { color: 'nano army', image_path: nanoThumb3 },
      { color: 'nano mustard', image_path: nanoThumb4 },
    ],
    size: ['m', 'l', 'xl'],
    image: [nanoThumb5, nanoThumb6, nanoThumb7],
  },
  //   tees
  {
    name: 'tees japan series',
    category: 't-shirt',
    price: 99000,
    variant: [
      { color: 'japan tiger', image_path: japanThumb1 },
      { color: 'dragon japan', image_path: japanThumb2 },
      { color: 'deer japan', image_path: japanThumb3 },
      { color: 'fish japan', image_path: japanThumb4 },
    ],
    size: ['m', 'l', 'xl'],
    image: [japanThumb5, japanThumb6],
  },
  {
    name: 'tees carbon mv-11',
    category: 't-shirt',
    price: 56000,
    variant: [
      { color: 'green canyon', image_path: carbonThumb1 },
      { color: 'dark grey', image_path: carbonThumb2 },
      { color: 'royal blue', image_path: carbonThumb3 },
      { color: 'maroon misty', image_path: carbonThumb4 },
    ],
    size: ['m', 'l', 'xl', 'xxl'],
    image: [carbonThumb5],
  },
  {
    name: 'tees tribow',
    category: 't-shirt',
    price: 56000,
    variant: [
      {
        color: 'black red green',
        image_path: tribowThumb1,
      },
      {
        color: 'green yellow white',
        image_path: tribowThumb2,
      },
      {
        color: 'red black white',
        image_path: tribowThumb3,
      },
      {
        color: 'navy red green',
        image_path: tribowThumb4,
      },
      {
        color: 'yellow black white',
        image_path: tribowThumb5,
      },
    ],
    size: ['m', 'l', 'xl'],
    image: [tribowThumb6, tribowThumb7, tribowThumb8],
  },
  //   T- shirt
  {
    name: 't-shirt amrailo series',
    category: 't-shirt',
    price: 89000,
    variant: [
      {
        color: 'black pattern gold',
        image_path: amariloThumb1,
      },
      {
        color: 'green leaf',
        image_path: amariloThumb2,
      },
      {
        color: 'straight rainbow',
        image_path: amariloThumb3,
      },
      {
        color: 'leopard',
        image_path: amariloThumb4,
      },
      {
        color: 'rellow',
        image_path: amariloThumb5,
      },
      {
        color: 'whale',
        image_path: amariloThumb6,
      },
    ],
    size: ['m', 'l', 'xl', 'xxl'],
    image: [amariloThumb7, amariloThumb8, amariloThumb9],
  },
  {
    name: 't-shirt aston series',
    category: 't-shirt',
    price: 89000,
    variant: [
      {
        color: 'black',
        image_path: astonThumb1,
      },
      {
        color: 'navy',
        image_path: astonThumb2,
      },
      {
        color: 'grey',
        image_path: astonThumb3,
      },
      {
        color: 'cream',
        image_path: astonThumb4,
      },
    ],
    size: ['m', 'l', 'xl'],
    image: [astonThumb5, astonThumb6, astonThumb7],
  },
  {
    name: 't-shirt dallas series',
    category: 't-shirt',
    price: 89000,
    variant: [
      {
        color: 'black',
        image_path: dallasThumb1,
      },
      {
        color: 'white',
        image_path: dallasThumb2,
      },
      {
        color: 'navy',
        image_path: dallasThumb3,
      },
      {
        color: 'maroon',
        image_path: dallasThumb4,
      },
      {
        color: 'dark grey',
        image_path: dallasThumb5,
      },
      {
        color: 'green',
        image_path: dallasThumb6,
      },
      {
        color: 'army',
        image_path: dallasThumb7,
      },
    ],
    size: ['m', 'l', 'xl'],
    image: [dallasThumb8, dallasThumb9, dallasThumb10],
  },
  {
    name: 't-shirt flanel premium',
    category: 't-shirt',
    price: 129000,
    variant: [
      {
        color: 'red black cream',
        image_path: flanelThumb1,
      },
      {
        color: 'blue white',
        image_path: flanelThumb2,
      },
      {
        color: 'square grey',
        image_path: flanelThumb3,
      },
      {
        color: 'brown grey navy',
        image_path: flanelThumb4,
      },
      {
        color: 'square line grey',
        image_path: flanelThumb5,
      },
      {
        color: 'square grey navy',
        image_path: flanelThumb6,
      },
    ],
    size: ['m', 'l', 'xl'],
    image: [flanelThumb7, flanelThumb8, flanelThumb9],
  },
  // oversize
  {
    name: 'oversize daviribs',
    category: 'oversize',
    price: 99000,
    variant: [],
    size: ['m', 'l', 'xl'],
    image: [daviribsThumb1, daviribsThumb2],
  },
  {
    name: 'oversize music light',
    category: 'oversize',
    price: 99000,
    variant: [],
    size: ['m', 'l', 'xl'],
    image: [musiclightThumb1, musiclightThumb2],
  },
  {
    name: 'oversize orange bear',
    category: 'oversize',
    price: 99000,
    variant: [
      { color: 'black', image_path: orangebearThumb1 },
      { color: 'white', image_path: orangebearThumb2 },
    ],
    size: ['m', 'l', 'xl'],
    image: [orangebearThumb1, orangebearThumb2, orangebearThumb3],
  },
]

export const shuffleProducts = shuffle(products)
